import { combineLatest } from 'rxjs';

import { AppStore } from '~/types/main.types';

import { BugsnagService } from '@mode/shared/util-error-handling';
import { transientSelectedQueryTokenSelector } from '../reducers/selectors';
import { QueryDataService } from './query-data-service';

export class LoggingService {
  static $inject = ['BugsnagService', 'RxStoreService', 'QueryDataService'];

  constructor(
    private bugsnag: BugsnagService,
    private store: AppStore,
    private queryDataService: QueryDataService
  ) {
    // Log invalid query selection
    combineLatest([
      this.store.select(transientSelectedQueryTokenSelector),
      this.store.select('client', 'selectedReport', 'queries'),
    ]).subscribe(([queryToken, queries]) => {
      if (queryToken && !queries.getRecord(queryToken)) {
        this.bugsnag.notify(new ReferenceError('Selected query token not available in queries'));
      }
    });

    // Log invalid editor query selection
    this.queryDataService.editorQueriesAndSelected$.subscribe(function (state) {
      if (state.selectedToken && !state.selectedQuery) {
        this.bugsnag.notify(new ReferenceError('Invalid query selection made in editor'));
      }
    });
  }
}
